import { render } from "./MentorMenteeView.vue?vue&type=template&id=6ef819e5"
import script from "./MentorMenteeView.vue?vue&type=script&lang=js"
export * from "./MentorMenteeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__